import { useState, useEffect } from 'react';
import { createElement } from 'react';
import ProductList from '../product-list';
import { childrenFunc } from '../../utils/childrenFunc';
import { Brief } from './list/ListItem';
import RadioItem from './RadioItem';
import List from './list';
Radio.RadioItem = RadioItem;
Radio.defaultProps = {
    data: [],
    hideLine: true,
    prefixCls: 'im-radio',
    row: false,
    type: 'normal',
    isLimitedWrap: true,
};
function Radio(props) {
    const { isLimitedWrap, hideLine, row, data, type, onChange, prefixCls, ...restProps } = props;
    const [selected, setSected] = useState(-1);
    const [dataInner, setDataInner] = useState(data || []);
    useEffect(() => {
        dataInner?.forEach((element) => {
            if (element.checked) {
                setSected(element.value);
            }
            if (!element.checked) {
                element.checked = false;
            }
            if (!element.disabled) {
                element.disabled = false;
            }
        });
    }, []);
    const itemOnClick = (item, index) => {
        dataInner?.forEach((ele) => {
            if (item.value === ele.value) {
                ele.checked = true;
            }
            else {
                ele.checked = false;
            }
        });
        setDataInner(dataInner);
        setSected(item.value);
        onChange?.({ target: { ...dataInner?.[index] } });
    };
    return (createElement(React.Fragment, null, dataInner && dataInner.length > 0 ? (createElement(List, { hideLine: hideLine, row: row, type: type }, dataInner.map((item, index) => item?.data1 ? (createElement(RadioItem, Object.assign({ key: item.value, newStyle: Boolean(item.newStyle), checked: Boolean(item.checked), disabled: Boolean(item.disabled), row: Boolean(item.row), cardRow: row, type: type, onClick: () => itemOnClick(item, index) }, restProps), item.content ? (childrenFunc(item.content)) : (createElement(ProductList, { data: item.data1 })))) : (createElement(RadioItem, Object.assign({ key: item.value, checked: Boolean(item.checked), disabled: Boolean(item.disabled), extra: Boolean(item.extra), row: Boolean(item.row), cardRow: row, type: type, onClick: () => itemOnClick(item, index) }, restProps), item.content ? (childrenFunc(item.content)) : (createElement(React.Fragment, null,
        item.icon && !item.cardIcon ? (createElement("img", { src: item.icon, className: `${prefixCls}-icon`, alt: item.iconAlt })) : null,
        item.cardIcon && (createElement("img", { src: item.cardIcon, className: `${prefixCls}-cardIcon`, alt: item.cardIconAlt })),
        createElement("div", { className: item.row
                ? `${prefixCls}-rowWrap ${prefixCls}column`
                : `${prefixCls}column` },
            !item.labelContent && createElement("div", { className: `${prefixCls}-label`, style: type === 'normal'
                    ? {
                        marginRight: '5px',
                        display: isLimitedWrap
                            ? '-webkit-box'
                            : 'flex',
                        ...item.labelStyle
                    }
                    : {
                        marginRight: '5px',
                        ...item.labelStyle
                    } },
                item.label,
                item.badge && createElement("span", { className: `${prefixCls}-badge`, style: item.badgeStyle }, item.badge)),
            item.labelContent && createElement("div", null, item.labelContent),
            item.extra ? (createElement(Brief, { style: item.row
                    ? {
                        padding: '0px',
                        display: isLimitedWrap
                            ? '-webkit-box'
                            : 'flex',
                    }
                    : {
                        display: isLimitedWrap
                            ? '-webkit-box'
                            : 'flex',
                        paddingTop: item.label ? '5px' : '0px',
                    } }, item.extra)) : null,
            item.slotData ? (createElement("div", { style: { padding: '10px 0' } }, item.slotData)) : null)))))))) : null));
}
export default Radio;
export { RadioProps } from './PropsType';
